// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input[data-v-65270d58] {\n  margin-top: 8px;\n}", ""]);
// Exports
module.exports = exports;
